import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import {MatDialog} from '@angular/material/dialog';
import {select, Store} from '@ngrx/store';
import {Zeitstate} from '../../../Zeiterfassung/store/reducer/zeiterfassung.reducer';
import {FirmaZeitItem} from '@src/app/pages/Mitarbeiterverwaltung/firmaZeit.model';
import {BestaetigungsFormComponent} from '@src/app/ui-components/bestaetigungs-form/bestaetigungs-form.component';
import {deleteFirmaZeitStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/firmaZeiten-del.actions';
import {FirmaZeitFormdialogComponent} from '@src/app/pages/Mitarbeiterverwaltung/components/firmazeiten-form-dialog/firmazeiten-formdialog.component';
import {SaldoItem} from '@src/app/pages/Mitarbeiterverwaltung/saldo.model';
import {UserInfoItem} from '@src/app/pages/Mitarbeiterverwaltung/userInfo.model';
import {UserinfoFormdialogComponent} from '@src/app/pages/Mitarbeiterverwaltung/components/userinfo-form-dialog/userinfo-formdialog.component';
import {deleteUserInfoStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/saldo-del.actions';

@Component({
    selector: 'app-saldo-table',
    templateUrl: './saldo-table.component.html',
    styleUrls: ['./saldo-table.component.scss'],
})
export class SaldoTableComponent implements OnInit {
  public displayedColumns: string[] = [
    'jahr',
    '%',
    'ferien',
    'actions',
  ];

  public dataSource = new MatTableDataSource<UserInfoItem>();

  constructor( public dialog: MatDialog , public store: Store<{ zeiterfassung: Zeitstate }> ) {
  }

  @Input()
  public showFunctionMenu = true;

  @Input()
  public zeitId: number;


  @Input()
  public set saldo(saldo: UserInfoItem[]) {
    this.dataSource.data = saldo;

  }


    public ngOnInit(): void {

    }

  public editUserinfo(firmaZeit: UserInfoItem): void {
    this.dialog.open(UserinfoFormdialogComponent, {
      data: {
        title: 'pages.mitarbeiterverwaltung.userinfo.editUserinfo',
        submitButtonLabel: 'pages.addTimeDialog.submitButtonLabel',
        cancelButtonLabel: 'pages.addTimeDialog.cancelButtonLabel',
        id: firmaZeit.id,
        datum: firmaZeit.datum,
        prozent: firmaZeit.prozent,
        ferien: firmaZeit.ferien,
        userId: firmaZeit.userId,
        saldoFerien: firmaZeit.saldoFerien,
        saldoZeit: firmaZeit.saldoZeit
      },
    });
  }

  public deleteUserinfo(saldo: UserInfoItem): void {
    const bestätigungsForm = this.dialog.open(BestaetigungsFormComponent, {
      data: {
        title: 'pages.mitarbeiterverwaltung.deleteUserInfo.title',
        text: 'pages.mitarbeiterverwaltung.deleteUserInfo.text',
      },
    });
    bestätigungsForm.afterClosed().subscribe(result => {
      if (result === true){
        this.store.dispatch(deleteUserInfoStart({item: saldo.id, userId: saldo.userId}));
      }
    });

  }


}
